export const CREDIT_SOFT_PULL_LOOKUP_FAILED = 'CREDIT_SOFT_PULL_LOOKUP_FAILED';
export const MAINTENANCE_MODE = 'MAINTENANCE_MODE';
